<script setup lang="ts">
import { localize } from "@/utils";
import { reactive, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Swiper as SwiperClass } from "swiper/types";
import { Navigation } from "swiper/modules";
import ActionMenu from "@/components/ActionMenu.vue";
</script>

<template>
  <div id="dashboard" class="grid">
    <div class="grid-side profile-bx">
      <div class="fs-24">
        <span>Hello, Mega Kim.</span>
        <p class="d-block font-weight-bold">You have <b class="text-primary">10</b> Action Needs.</p>
      </div>
      <ul class="nav dashboard-nav font-weight-bold pb-2">
        <li>
          <a href="" class="d-flex align-items-center nav-link active"
            >All <span class="d-block badge bg-primary text-white ml-2">24</span></a
          >
        </li>
        <li>
          <a href="" class="d-flex align-items-center nav-link"
            >Action Needs<span class="d-block badge bg-primary text-white ml-2">10</span></a
          >
        </li>
        <li>
          <a href="" class="d-flex align-items-center nav-link"
            >In Progress<span class="d-block badge bg-primary text-white ml-2">4</span></a
          >
        </li>
      </ul>
      <div class="main-card-wrp w-100">
        <div class="main-card card">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <span class="badge bg-red">D-0</span>
            <div class="profile-wrap row align-items-center fs-xs font-weight-bold">
              <div class="profile-thumb col-auto">
                <img src="@/assets/playground/img/_temp/profile2.jpg" alt="" />
              </div>
              <div class="profile-txt col pl-1">
                <p class="strong">Unjoo Planner</p>
              </div>
            </div>
          </div>
          <p class="font-poppins fs-3 mb-2">R2 Planning & Guide<br />Design</p>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <b class="fs-sm">up to 24.00.00 00:00</b>
            <span class="fs-xs text-muted">Ordering 24.00.00</span>
          </div>
          <div class="bg-light-purple rounded row align-items-center pt-2 pb-2">
            <div class="col text-nowrap text-muted font-weight-bold">State</div>
            <div class="col-auto">
              <span class="fs-sm pr-2">Order Closed</span>
              <span class="fs-xs badge bg-ylw">Reguired</span>
            </div>
          </div>
        </div>
        <div class="main-card card">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <span class="badge bg-light-purple text-primary">D-10</span>
            <div class="profile-wrap row align-items-center fs-xs font-weight-bold">
              <div class="profile-thumb col-auto">
                <img src="@/assets/playground/img/_temp/profile2.jpg" alt="" />
              </div>
              <div class="profile-txt col pl-1">
                <p class="strong">Unjoo Planner</p>
              </div>
            </div>
          </div>
          <p class="font-poppins fs-3 mb-2">R2 Planning & Guide<br />Design</p>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <b class="fs-sm">up to 24.00.00 00:00</b>
            <span class="fs-xs text-muted">Ordering 24.00.00</span>
          </div>
          <div class="bg-light-purple rounded row align-items-center pt-2 pb-2">
            <div class="col text-nowrap text-muted font-weight-bold">State</div>
            <div class="col-auto">
              <span class="fs-sm pr-2">Order Closed</span>
              <span class="fs-xs badge bg-ylw">Reguired</span>
            </div>
          </div>
        </div>
        <div class="main-card card pt-0">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <span class="badge bg-light-purple text-primary">D-10</span>
            <div class="profile-wrap row align-items-center fs-xs font-weight-bold">
              <div class="profile-thumb col-auto">
                <img src="@/assets/playground/img/_temp/profile2.jpg" alt="" />
              </div>
              <div class="profile-txt col pl-1">
                <p class="strong">Unjoo Planner</p>
              </div>
            </div>
          </div>
          <p class="font-poppins fs-3 mb-2">R2 Planning & Guide<br />Design</p>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <b class="fs-sm">up to 24.00.00 00:00</b>
            <span class="fs-xs text-muted">Ordering 24.00.00</span>
          </div>
          <div class="bg-light-purple rounded row align-items-center pt-2 pb-2">
            <div class="col text-nowrap text-muted font-weight-bold">State</div>
            <div class="col-auto">
              <span class="fs-sm pr-2">Order Closed</span>
              <span class="fs-xs badge bg-ylw">Reguired</span>
            </div>
          </div>
        </div>
        <div class="main-card card pt-0">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <span class="badge bg-light-purple text-primary">D-10</span>
            <div class="profile-wrap row align-items-center fs-xs font-weight-bold">
              <div class="profile-thumb col-auto">
                <img src="@/assets/playground/img/_temp/profile2.jpg" alt="" />
              </div>
              <div class="profile-txt col pl-1">
                <p class="strong">Unjoo Planner</p>
              </div>
            </div>
          </div>
          <p class="font-poppins fs-3 mb-2">R2 Planning & Guide<br />Design</p>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <b class="fs-sm">up to 24.00.00 00:00</b>
            <span class="fs-xs text-muted">Ordering 24.00.00</span>
          </div>
          <div class="bg-light-purple rounded row align-items-center pt-2 pb-2">
            <div class="col text-nowrap text-muted font-weight-bold">State</div>
            <div class="col-auto">
              <span class="fs-sm pr-2">Order Closed</span>
              <span class="fs-xs badge bg-ylw">Reguired</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-content flex-layout">
      <!-- 액션 메뉴 -->
      <action-menu></action-menu>
      <!-- //액션 메뉴 -->

      <div id="ct" class="flex-layout-body ml0">
        <div class="mt-3 mb-5">
          <h1 class="fs-2 d-flex align-items-center mb-4">
            Action Needs
            <p class="flex-center text-primary fs-sm ml-3">
              <a href="#"><span class="pr-2">View more</span> <i class="icon icon-arrow-primary"></i></a>
            </p>
          </h1>
          <div class="d-flex action-card-wrp">
            <div class="card bg-white col">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted font-weight-bold fs-xs"
                  >Order<br />
                  rejected</span
                >
                <i class="icon-order-rejected"></i>
              </div>
              <div class="d-flex align-items-center">
                <b class="fs-32 font-poppins d-block mr-2">35</b>
                <span class="fs-sm text-muted font-weight-bold">Orders</span>
              </div>
            </div>
            <div class="card bg-white col">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted font-weight-bold fs-xs">Prepaid</span>
                <i class="icon-prepaid"></i>
              </div>
              <div class="d-flex align-items-center">
                <b class="fs-32 font-poppins d-block mr-2">10</b>
                <span class="fs-sm text-muted font-weight-bold">Orders</span>
              </div>
            </div>
            <div class="card bg-white col">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted font-weight-bold fs-xs"
                  >Confirmation<br />
                  Required</span
                >
                <i class="icon-confirmation-required"></i>
              </div>
              <div class="d-flex align-items-center">
                <b class="fs-32 font-poppins d-block mr-2">24</b>
                <span class="fs-sm text-muted font-weight-bold">Orders</span>
              </div>
            </div>
            <div class="card bg-white col">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted font-weight-bold fs-xs">Design<br />Completed</span>
                <i class="icon-desconf-approved"></i>
              </div>
              <div class="d-flex align-items-center">
                <b class="fs-32 font-poppins d-block mr-2">8</b>
                <span class="fs-sm text-muted font-weight-bold">Orders</span>
              </div>
            </div>
            <div class="card bg-white col">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <span class="text-muted font-weight-bold fs-xs"
                  >Order Closed<br />
                  Requested</span
                >
                <i class="icon-ordclose-requested"></i>
              </div>
              <div class="d-flex align-items-center">
                <b class="fs-32 font-poppins d-block mr-2">4</b>
                <span class="fs-sm text-muted font-weight-bold">Orders</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-between mb-5">
          <div class="partner-swiper-wrp col">
            <h1 class="fs-2 mb-4">Favorite Partner</h1>
            <div class="partner-swiper">
              <div class="d-flex justify-content-between align-items-center">
                <ul class="round-sort">
                  <li class="active">All</li>
                  <li>Planner</li>
                  <li>R2 Center</li>
                </ul>
                <div class="swiper-btn-wrp">
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
              </div>
              <swiper
                class="mt-4"
                slides-per-view="auto"
                :space-between="16"
                :modules="[Navigation]"
                :navigation="{
                  nextEl: '.partner-swiper .swiper-button-next',
                  prevEl: '.partner-swiper .swiper-button-prev',
                }"
              >
                <swiper-slide>
                  <div class="card">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="profile-thumb">
                        <img src="@/assets/playground/img/_temp/profile.jpg" alt="" />
                      </div>
                      <div class="meta mt-2">
                        <i class="icon icon-star">평점</i>4.9 / 5.0
                        <i class="icon icon-heart active">찜</i>
                      </div>
                    </div>
                    <div class="font-poppins">
                      <p class="fs-sm text-primary">Planner</p>
                      <b>Frank,. Wechen. Bauer</b>
                    </div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="badge text-truncate mr-2">R2 Planning & Guide Design</div>
                      <span class="text-primary font-weight-bold">+2</span>
                    </div>
                    <div class="text-center mt-4">
                      <a href="" class="btn btn-outline-primary w-100">View more +</a>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="card">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="profile-thumb">
                        <img src="@/assets/playground/img/_temp/profile.jpg" alt="" />
                      </div>
                      <div class="meta mt-2">
                        <i class="icon icon-star">평점</i>4.9 / 5.0
                        <i class="icon icon-heart active">찜</i>
                      </div>
                    </div>
                    <div class="font-poppins">
                      <p class="fs-sm text-primary">Planner</p>
                      <b>Frank,. Wechen. Bauer</b>
                    </div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="badge text-truncate mr-2">R2 Planning & Guide Design</div>
                      <span class="text-primary font-weight-bold">+2</span>
                    </div>
                    <div class="text-center mt-4">
                      <a href="" class="btn btn-outline-primary w-100">View more +</a>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="card">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="profile-thumb">
                        <img src="@/assets/playground/img/_temp/profile.jpg" alt="" />
                      </div>
                      <div class="meta mt-2">
                        <i class="icon icon-star">평점</i>4.9 / 5.0
                        <i class="icon icon-heart active">찜</i>
                      </div>
                    </div>
                    <div class="font-poppins">
                      <p class="fs-sm text-primary">Planner</p>
                      <b>Frank,. Wechen. Bauer</b>
                    </div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="badge text-truncate mr-2">R2 Planning & Guide Design</div>
                      <span class="text-primary font-weight-bold">+2</span>
                    </div>
                    <div class="text-center mt-4">
                      <a href="" class="btn btn-outline-primary w-100">View more +</a>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="card">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="profile-thumb">
                        <img src="@/assets/playground/img/_temp/profile.jpg" alt="" />
                      </div>
                      <div class="meta mt-2">
                        <i class="icon icon-star">평점</i>4.9 / 5.0
                        <i class="icon icon-heart active">찜</i>
                      </div>
                    </div>
                    <div class="font-poppins">
                      <p class="fs-sm text-primary">Planner</p>
                      <b>Frank,. Wechen. Bauer</b>
                    </div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="badge text-truncate mr-2">R2 Planning & Guide Design</div>
                      <span class="text-primary font-weight-bold">+2</span>
                    </div>
                    <div class="text-center mt-4">
                      <a href="" class="btn btn-outline-primary w-100">View more +</a>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <div class="trendings-swiper-wrp col">
            <div class="trendings-swiper">
              <div class="d-flex justify-content-between align-items-center">
                <h1 class="fs-2 mb-4">Favorite Partner</h1>
                <div class="swiper-btn-wrp">
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
              </div>

              <swiper
                class="mt-4"
                :modules="[Navigation]"
                :navigation="{
                  nextEl: '.trendings-swiper .swiper-button-next',
                  prevEl: '.trendings-swiper .swiper-button-prev',
                }"
              >
                <swiper-slide>
                  <div class="card trendings-card card-flat">
                    <img src="@/assets/playground/img/_temp/img4.jpg" alt="" class="trendings-img" />

                    <div class="trendings-card-inner">
                      <div class="d-flex justify-content-end">
                        <img src="@/assets/playground/img/youtube.png" alt="" />
                      </div>
                      <div>
                        <span class="badge bg-red">Youtube Live</span>
                        <p class="mt-1 font-poppins fs-24 font-weight-bold text-white text-nowrap text-truncate">
                          Perio Park’s Live Surgery
                        </p>
                        <span class="d-block mt-2 font-poppins text-white">2024.02.05 PM 08:00 ~</span>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="card trendings-card card-flat">
                    <img src="@/assets/playground/img/_temp/img3.jpg" alt="" class="trendings-img" />

                    <div class="trendings-card-inner">
                      <div class="d-flex justify-content-end">
                        <img src="@/assets/playground/img/youtube.png" alt="" />
                      </div>
                      <div>
                        <span class="badge bg-red">Youtube Live</span>
                        <p class="mt-1 font-poppins fs-24 font-weight-bold text-white text-nowrap text-truncate">
                          Perio Park’s Live Surgery
                        </p>
                        <span class="d-block mt-2 font-poppins text-white">2024.02.05 PM 08:00 ~</span>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div class="dashboard-banner-wrp font-poppins d-flex align-items-center">
          <b>Upcoming<br />Events</b>
          <div class="dashboard-banner ylw w-100">
            <div class="inner font-poppins">
              <b class="d-block">Perio Parks QnA</b>
              <span class="d-block mt-2 badge fs-sm">24.00.00 16:00~</span>
            </div>
            <img src="@/assets/playground/img/dashboard-banner-icon.png" alt="" />
          </div>
          <div class="dashboard-banner navy w-100">
            <div class="inner font-poppins">
              <b class="d-block text-white">Perio Parks QnA</b>
              <span class="d-block mt-2 badge fs-sm text-white">24.00.00 16:00~</span>
            </div>
            <img src="@/assets/playground/img/dashboard-banner-icon.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
